<div mat-dialog-content>
    <div class="profile-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-genCenterCostNew (closeDialog)="onClose()" [centerCostId]="centerCostId"></app-genCenterCostNew>
</div>